import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import KogAutoCompleteVehicleControlled from "@/main/components/shared/inputAutoComplete/autoCompleteVehicleControlled";

import { KeyValue } from "@/main/models/common";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { getManufacturers, resetReducerManufacturers, useManufacturerReducer } from "@/main/store/vehicle/manufacturer";
import { getModels, resetReducerModels, useModelReducer } from "@/main/store/vehicle/model";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";

export const INITIAL_FORM_STATE_MODEL = {
	manufacturer: null as KeyValue | null,
	model: null as KeyValue | null,
};

export type IFormFiltersMappingTypeModel = typeof INITIAL_FORM_STATE_MODEL;

interface IFiltersMappingTypeModelProps {}

function FiltersMappingTypeModel(_props: IFiltersMappingTypeModelProps) {
	const dispatch = useDispatch();
	const { keyReducer, isRequiredField } = useDinamicFiltersMappingCodes();
	const { isolated: manufacturerReducer } = useManufacturerReducer(keyReducer);
	const { isolated: modelsReducer } = useModelReducer(keyReducer);
	const { control, setValue, resetField, watch } = useFormContext<IFormFiltersMappingTypeModel>();

	const watcherManufacturer = watch("manufacturer");

	useEffect(() => {
		resetField("manufacturer");
		resetField("model");

		dispatch(getManufacturers({}, keyReducer));

		return () => {
			dispatch(resetReducerManufacturers(keyReducer));
			dispatch(resetReducerModels(keyReducer));
		};
	}, []);

	useEffect(() => {
		dispatch(resetReducerModels(keyReducer));
		resetField("model");
		dispatch(getModels({ guidManufacturer: String(watcherManufacturer?.key) }, keyReducer));
	}, [watcherManufacturer?.key]);

	const disabledManufacturer = isNullUndefined(manufacturerReducer.data) || manufacturerReducer.data.length === 1;
	const disabledModel = isNullUndefined(modelsReducer.data) || modelsReducer.data.length === 1;
	return (
		<>
			{
				<KogAutoCompleteVehicleControlled
					id="id-mappingCode-select-manufacturer"
					nameCustom="manufacturer"
					label={getTranslateByKey("information.manufacturer")}
					isDefaultValueUnique
					control={control}
					setValueCustom={setValue}
					options={manufacturerReducer.data}
					isLoading={manufacturerReducer.isLoading}
					disabled={disabledManufacturer}
					rulesCustom={{ required: isRequiredField("manufacturer") }}
					onChangeCustom={() => {}}
				/>
			}
			<KogAutoCompleteVehicleControlled
				id="id-mappingCode-select-model"
				nameCustom="model"
				label={getTranslateByKey("information.model")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={modelsReducer.data}
				isLoading={modelsReducer.isLoading}
				disabled={disabledModel}
				rulesCustom={{ required: isRequiredField("model") }}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default FiltersMappingTypeModel;
